module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "assign-box",
    attrs: {
      "row": "",
      "wrap": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "label-medium"
  }, [_vm._v("Mucamas asignadas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": "",
      "body-border-bottom": ""
    }
  }, [_c('user-selector', {
    key: _vm.housemaid.id,
    attrs: {
      "user": _vm.housemaid
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": "",
      "pt-2": ""
    }
  }, [_c('p', {
    staticClass: "label-medium mb-0"
  }, [_vm._v("Datos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": "",
      "pt-2": ""
    }
  }, [_c('list-detail-description', {
    staticClass: "px-2",
    attrs: {
      "details": _vm.details
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "pt-2": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table no-search-table table-custom-options table-housemaid-assign",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-search": false,
      "include-options": true,
      "include-export-to-excel": false,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-drag-event": _vm.setRowSelected,
      "on-drop-event": _vm.sortableRows
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.roomtype_name))]), _vm._v(" "), _c('td', [_c('span', {
          staticClass: "square-state",
          style: (("background-color: " + (props.row.color_state)))
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.row.room_state_name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.hot_floor_id))]), _vm._v(" "), _c('td', [_c('v-select', {
          staticClass: "select-housemaid-assign",
          attrs: {
            "items": _vm.items,
            "item-text": "name",
            "item-value": "id",
            "hide-details": "",
            "single-line": "",
            "bottom": ""
          },
          on: {
            "input": function($event) {
              _vm.changeTypeCleaning(props.row)
            }
          },
          model: {
            value: (props.row.type_clean),
            callback: function($$v) {
              props.row.type_clean = $$v
            },
            expression: "props.row.type_clean"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
          staticClass: "time-standard-input",
          attrs: {
            "type": "number",
            "suffix": "min",
            "min": "1",
            "step": "1",
            "hide-details": ""
          },
          on: {
            "keyup": function($event) {
              _vm.toInt(props.row.time_standard)
            }
          },
          model: {
            value: (props.row.time_standard),
            callback: function($$v) {
              props.row.time_standard = _vm._n($$v)
            },
            expression: "props.row.time_standard"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right pr-2 options-column options-column-housemaids",
          class: {
            'active': props.row.classActive
          }
        }, [_c('div', {
          staticClass: "arrow-move"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/move.svg",
            "alt": ""
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "delete-item"
        }, [_c('v-icon', {
          staticClass: "delete-icon",
          on: {
            "click": function($event) {
              _vm.deleteRow(props.row.id)
            }
          }
        }, [_vm._v("close")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "pt-2": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-assign-tasks",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.assignHousemaid
    }
  }, [_vm._v("\n\t\t\tEnviar\n\t\t")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07473fb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/housemaids/Assign.vue
// module id = 1578
// module chunks = 49